import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AdminAuthService } from '@app/services/admin-auth/admin-auth.service';
import { AdminTenantService } from '@app/services/admin-tenant/admin-tenant.service';
import { AdminUserService } from '@app/services/admin-user/admin-user.service';

export const superAdminGuard = () => {
  const adminAuthService = inject(AdminAuthService);
  const adminUserService = inject(AdminUserService);
  const adminTenantService = inject(AdminTenantService);
  const adminUser = adminUserService.getUser();
  const isSuperAdmin = adminAuthService.isSuperAdmin(adminUser?.roles);
  const router = inject(Router);

  if (!isSuperAdmin) {
    return router.parseUrl(adminTenantService.getDefaultLandingRoute());
  }

  return true;
};

export const superAdminChildGuard: CanActivateChildFn = () => {
  return superAdminGuard();
};
